import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IChecklist, IChecklistRequest } from '../interfaces/checklist.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) {}

  getChecklists(): Observable<any> {
    const request = {
      tope: '999',
      numAct: 0,
      descripcion: ''
    };

    return this.http.post<any>(`${this.apiUrl}RutaCritica/GetCatChkLs`, request);
  }

  getChecklistDetail(numAct: string): Observable<any> {
    const request = {
      que: 5,
      tope: '',
      cmd: '',
      numAct: parseInt(numAct),
      descripcion: ''
    };

    return this.http.post<any>(`${this.apiUrl}CheckList/cmspa_CatChkLsListDet`, request);
  }

  saveChecklist(data: IChecklist): Observable<any> {
    const request: IChecklistRequest = {
      que: 1,
      tope: '',
      cmd: '',
      numAct: data.numAct,
      descripcion: data.descripcion
    };

    return this.http.post<any>(`${this.apiUrl}CheckList/cmspa_CatChkLsAdd`, request);
  }

  updateChecklist(data: IChecklist): Observable<any> {
    const request = {
      que: 2,
      tope: '',
      cmd: '',
      numAct: data.numAct,
      descripcion: data.descripcion
    };

    return this.http.post<any>(`${this.apiUrl}CheckList/cmspa_CatChkLsUpd`, request);
  }

  deleteChecklist(numAct: string): Observable<any> {
    const request = {
      que: 3,
      tope: '',
      cmd: '',
      numAct: parseInt(numAct),
      descripcion: ''
    };

    return this.http.post<any>(`${this.apiUrl}CheckList/cmspa_CatChkLsDelete`, request);
  }
} 